import React, { useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../features/auth/authSlice";
import { message as msg } from "antd";
import { Card, Space } from "antd";

let schema = yup.object().shape({
  email: yup
    .string()
    .email("Email should be valid")
    .required("Email is Required"),
  password: yup.string().required("Password is Required"),
});
const Login = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [remember_me, setRememberMe] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember_me: false,
    },
    validationSchema: schema,
    onSubmit: (values) => {
      dispatch(login({ ...values, remember_me }));
    },
  });
  const { user, isError, isLogin, isLoading, message } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }
    if (isLogin) {
      navigate("admin");
    } else {
      navigate("");
    }
  }, [user, isError, isLogin, isLoading, message, messageApi, navigate]);

  return (
    <>
      {contextHolder}
      <div
        className="py-5 p-4"
        style={{ background: "white", minHeight: "100vh" }}
      >
        <div
          className="my-5 mx-auto p-4 bg-white rounded-3"
          style={{ maxWidth: "500px" }}
        >
          <Space direction="vertical" size={16}>
            <Card title="Login" style={{ width: 500, textAlign: "center" }}>
              <h6 className="text-center">Login to your account to continue.</h6>
              <div className="error text-center">
                {message.message === "Rejected" ? "You are not an Admin" : ""}
              </div>
              <form action="" onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <CustomInput
                    type="text"
                    label="Email Address"
                    id="email"
                    name="email"
                    onChng={formik.handleChange("email")}
                    onBlr={formik.handleBlur("email")}
                    val={formik.values.email}
                  />
                  <div className="error mt-2">
                    {formik.touched.email && formik.errors.email}
                  </div>
                </div>
                <div className="mb-3">
                  <CustomInput
                    type="password"
                    label="Password"
                    id="pass"
                    name="password"
                    onChng={formik.handleChange("password")}
                    onBlr={formik.handleBlur("password")}
                    val={formik.values.password}
                  />
                  <div className="error mt-2">
                    {formik.touched.password && formik.errors.password}
                  </div>
                  
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="remember_me"
                        checked={remember_me}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="remember_me">
                        Remember Me
                      </label>
                    </div>
                    <Link to="forgot-password">
                      Forgot Password?
                    </Link>
                  </div>
                </div>

                <button
                  disabled={isLoading}
                  className="border-0 px-3 py-2 text-white fw-bold w-100 text-center text-decoration-none fs-5"
                  style={{ background: "#ffd333" }}
                  type="submit"
                >
                  {isLoading ? "Login ..." : "Login"}
                </button>
              </form>
            </Card>
          </Space>
        </div>
      </div>
    </>
  );
};

export default Login;
